import $ from "jquery";
import { useNavigate } from "react-router-dom";
import Eralogo22 from "../../assets/images/Eralogo22.png";
import Navigator from "../extra/Navigator";
import { warning } from "../../util/Alert";
import { useDispatch } from "react-redux";
import { LOGOUT_ADMIN } from "../store/admin/admin.type";
import { projectName } from "../../util/config";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    const data = warning();
    data
      .then((logout) => {
        if (logout) {
          dispatch({ type: LOGOUT_ADMIN });
          navigate("/");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCloseSideBar = () => {
    if (window.innerWidth <= 992) {
      $(".sideBar").toggleClass("mobSidebar webSidebar");
    }
  };

  const navBarArray = [
    {
      name: "Dashboard",
      path: "/admin/dashboard",
      iconName: "LayoutDashboard",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Product Management" },

    {
      name: "Attribute",
      path: "/admin/attribute",
      iconName: "Key",
      onClick: handleCloseSideBar,
    },
    {
      name: "Category",
      path: "/admin/category",
      path2: "/admin/category/subCategory",
      iconName: "Grid",
      onClick: handleCloseSideBar,
    },
    {
      name: "Slider",
      path: "/admin/slider",
      iconName: "Image",
      onClick: handleCloseSideBar,
    },
    {
      name: "Showcase",
      path: "/admin/showcase",
      iconName: "LayoutGrid",
      onClick: handleCloseSideBar,
    },
    {
      name: "PromoCode",
      path: "/admin/promocode",
      iconName: "Percent",
      onClick: handleCloseSideBar,
    },
    {
      name: "Product Request",
      iconName: "ShoppingCart",
      subMenu: [
        {
          subName: "Pending Requests",
          subPath: "/admin/pendingProduct",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Approved Requests",
          subPath: "/admin/approvedProduct",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Reject Requests",
          subPath: "/admin/rejectedProduct",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Product",
      // path: "/admin/product",
      iconName: "ShoppingBasket",
      subMenu: [
        {
          subName: "Real",
          subPath: "/admin/product",
          subPath2: "/admin/productDetail",
          subPath3: "/admin/addProduct",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Fake",
          subPath: "/admin/fakeproduct",
          subPath2: "/admin/fake/productDetail",
          subPath3: "/admin/fake/addProduct",
          // subPath4: "/admin/addProduct",
          // subPath4: "/admin/addProduct",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Reels",
      iconName: "Film",
      subMenu: [
        {
          subName: "Real",
          subPath: "/admin/reels",
          subPath2: "/admin/real/reels/details",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Fake",
          subPath: "/admin/fakereels",
          subPath2: "/admin/fake/reels/details",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Creator",
          subPath: "/admin/affiliateReels",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Review",
          subPath: "/admin/reelReview",
          onClick2: handleCloseSideBar,
        },
      ],
    },

    {
      name: "Ad Campaigns",
      path: "/admin/ads",
      iconName: "Monitor",
      onClick: handleCloseSideBar,
    },

    {
      name: "Boosts",
      path: "/admin/boosts",
      iconName: "Rocket",
      onClick: handleCloseSideBar,
    },

    {
      name: "Community",
      path: "/admin/community",
      iconName: "Users",
      onClick: handleCloseSideBar,
    },

    {
      name: "Challenges",
      path: "/admin/challenges",
      iconName: "Award",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Report Management" },

    {
      name: "Reels Report",
      path: "/admin/videoreport",
      iconName: "FileText",
      onClick: handleCloseSideBar,
    },

    {
      name: "Upload Failures",
      path: "/admin/uploadFailures",
      iconName: "AlertTriangle",
      onClick: handleCloseSideBar,
    },

    {
      name: "Live Starts",
      path: "/admin/liveStarts",
      iconName: "Radio",
      onClick: handleCloseSideBar,
    },

    {
      name: "Video Playback",
      path: "/admin/videoPlayback",
      iconName: "Activity",
      onClick: handleCloseSideBar,
    },

    {
      name: "Howyin Connect Reports",
      path: "/admin/socialReports",
      iconName: "Flag",
      onClick: handleCloseSideBar,
    },
    {
      name: "Community Reports",
      path: "/admin/communityReports",
      iconName: "Flag",
      onClick: handleCloseSideBar,
    },

    {
      name: "Report Reason",
      path: "/admin/reportreason",
      iconName: "TicketsPlane",
      onClick: handleCloseSideBar,
    },


    { sectionTitle: "Order & Seller" },

    {
      name: "Creator",
      iconName: "Users",
      subMenu: [
        {
          subName: "Pending Request",
          subPath: "/admin/affiliateRequest",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Approved Creators",
          subPath: "/admin/affiliate",
          subPath2: "/admin/affiliateProfile",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Creator Hires",
      path: "/admin/creatorHires",
      iconName: "Handshake",
      onClick: handleCloseSideBar,
    },
    {
      name: "Seller",
      iconName: "Store",
      subMenu: [
        {
          subName: "Pending Request",
          subPath: "/admin/sellerRequest",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Real Seller",
          subPath: "/admin/seller",
          subPath2: "/admin/sellerProfile",
          subPath3: "/admin/addSeller",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Fake Seller",
          subPath: "/admin/fakeSeller",

          subPath3: "/admin/addFakeSeller",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Service Provider",
      iconName: "Briefcase",
      subMenu: [
        {
          subName: "Pending Request",
          subPath: "/admin/serviceProviderRequest",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Categories",
          subPath: "/admin/serviceCategory",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Faith Leader",
      iconName: "ShieldCheck",
      subMenu: [
        {
          subName: "Pending Request",
          subPath: "/admin/faithLeaderRequest",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Withdrawals",
          subPath: "/admin/faithLeaderWithdraw",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Faith Quotes",
      iconName: "ShieldCheck",
      path: "/admin/faithQuotes",
      onClick: handleCloseSideBar,
    },
    {
      name: "Howyin Streaming Service",
      iconName: "MonitorPlay",
      path: "/admin/streamingPortal",
      onClick: handleCloseSideBar,
    },
    {
      name: "Live Seller",
      path: "/admin/liveseller",
      path2: "/admin/liveSellerProduct",
      iconName: "Radio",
      onClick: handleCloseSideBar,
    },
    {
      name: "Live History",
      path: "/admin/liveHistory",
      iconName: "History",
      onClick: handleCloseSideBar,
    },
    {
      name: "Sounds",
      path: "/admin/sounds",
      iconName: "Music",
      onClick: handleCloseSideBar,
    },
    {
      name: "Order",
      path: "/admin/order",
      path2: "/admin/order/orderDetail",
      iconName: "PackageCheck",
      onClick: handleCloseSideBar,
    },
    {
      name: "Logistics",
      path: "/admin/logistics",
      iconName: "Truck",
      onClick: handleCloseSideBar,
    },
    {
      name: "Shipping Methods",
      path: "/admin/shippingMethod",
      iconName: "Ship",
      onClick: handleCloseSideBar,
    },
    {
      name: "Sourcing Requests",
      path: "/admin/sourcingRequest",
      iconName: "Search",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "User Management" },

    {
      name: "User",
      path: "/admin/user",

      path2: "/admin/UserProfile",
      iconName: "Users",
      onClick: handleCloseSideBar,
    },
    {
      name: "Chat",
      path: "/admin/chat",
      path2: "/admin/chatDetails",
      iconName: "MessageCircle",
      onClick: handleCloseSideBar,
    },
    {
      name: "Support Chat",
      path: "/admin/supportChat",
      path2: "/admin/supportChatDetails",
      iconName: "Headphones",
      onClick: handleCloseSideBar,
    },
    {
      name: "Support Agents",
      path: "/admin/supportAgents",
      iconName: "UserCog",
      onClick: handleCloseSideBar,
    },
    // {
    //   name: "Seller Withdraw",
    //   path: "/admin/redeem",
    //   iconName: "Wallet",
    //   onClick: handleCloseSideBar,
    // },

    { sectionTitle: "Finance" },

    {
      name: "Seller Withdrawal",
      path: "/admin/adminwithdrawal",
      iconName: "Wallet",
      onClick: handleCloseSideBar,
    },

    {
      name: "Creator Withdrawal",
      path: "/admin/affiliatewithdrawal",
      iconName: "Gift",
      onClick: handleCloseSideBar,
    },

    {
      name: "Admin Earning",
      path: "/admin/wallet",
      iconName: "CreditCard",
      onClick: handleCloseSideBar,
    },
    {
      name: "Transaction History",
      path: "/admin/transactions",
      iconName: "Receipt",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Coins & Rewards" },

    {
      name: "Reward Wallets",
      path: "/admin/rewardWallets",
      iconName: "Coins",
      onClick: handleCloseSideBar,
    },
    {
      name: "Coin Ledger",
      path: "/admin/rewardTransactions",
      iconName: "ListOrdered",
      onClick: handleCloseSideBar,
    },
    {
      name: "Earning Rules",
      path: "/admin/earningRules",
      iconName: "Settings",
      onClick: handleCloseSideBar,
    },
    {
      name: "ID Verification",
      path: "/admin/kyc",
      iconName: "ShieldCheck",
      onClick: handleCloseSideBar,
    },
    {
      name: "Coin Packages",
      path: "/admin/coinPackage",
      iconName: "Coins",
      onClick: handleCloseSideBar,
    },
    {
      name: "Coin Bonus",
      path: "/admin/coinBonus",
      iconName: "Gift",
      onClick: handleCloseSideBar,
    },
    {
      name: "Adjust Coins",
      path: "/admin/addCoins",
      iconName: "CirclePlus",
      onClick: handleCloseSideBar,
    },
    {
      name: "Gifts",
      path: "/admin/gift",
      iconName: "Gift",
      onClick: handleCloseSideBar,
    },
    {
      name: "Gift Transactions",
      path: "/admin/giftTransaction",
      iconName: "ArrowRightLeft",
      onClick: handleCloseSideBar,
    },
    {
      name: "Cashout Requests",
      path: "/admin/cashoutRequest",
      iconName: "HandCoins",
      onClick: handleCloseSideBar,
    },

    { sectionTitle: "Help & Settings" },

    {
      name: "FAQ",
      path: "/admin/faq",
      iconName: "HelpCircle",
      onClick: handleCloseSideBar,
    },

    {
      name: "Popup Ads",
      iconName: "Megaphone",
      path: "/admin/popupAds",
      onClick: handleCloseSideBar,
    },
    {
      name: "Setting",
      iconName: "Settings",
      subMenu: [
        {
          subName: "App Setting",
          subPath: "/admin/setting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Payment Setting",
          subPath: "/admin/paymentSetting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Withdraw Setting",
          subPath: "/admin/withDraw",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Bank Setting",
          subPath: "/admin/bankSetting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Currency Setting",
          subPath: "/admin/currencySetting",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Exchange Rates",
          subPath: "/admin/exchangeRates",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Other Setting",
          subPath: "/admin/others",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Audit Logs",
      iconName: "ShieldCheck",
      subMenu: [
        {
          subName: "Payments",
          subPath: "/admin/payments",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Coins Logs",
          subPath: "/admin/coinsLogs",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Coins Leader",
          subPath: "/admin/coinsLeader",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Blocked Accounts",
          subPath: "/admin/blockedAccounts",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Gift / Transfer Logs",
          subPath: "/admin/giftTransferLogs",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Live Games",
          subPath: "/admin/liveGames",
          onClick2: handleCloseSideBar,
        },
        {
          subName: "Admin Logins",
          subPath: "/admin/adminLogins",
          onClick2: handleCloseSideBar,
        },
      ],
    },
    {
      name: "Website",
      path: "/admin/website",
      iconName: "Globe",
      onClick: handleCloseSideBar,
    },
    {
      name: "Profile",
      path: "/admin/profilePage",
      iconName: "User",
      onClick: handleCloseSideBar,
    },
    {
      name: "LogOut",
      iconName: "LogOut",
      onClick: handleLogout,
    },
  ];



  return (
    <>
      <div className="mainSidebar border-end " >
        <div className="sideBar webSidebar">
          <div
            className="sideBarLogo "
            onClick={() => navigate("/admin/dashboard")}
          >
            <img src={Eralogo22} alt="" width={"50px"} className="me-2" style={{ color: "#F0C420" }} />
            <span className="fs-3 fw-bold" style={{ color: "#F0C420", fontSize: "22px", fontWeight: "700" }}>
              {projectName}
            </span>
          </div>
          {/* ======= Navigation ======= */}
          <div className="navigation">
            <nav>
              {navBarArray.map((item, idx) => {
                if (item.sectionTitle) {
                  return (
                    <p
                      key={`section-${idx}`}
                      className="p-6 mb-1  mt-1 text-secondary  "
                      style={{ fontWeight: "300", fontSize: "15px", textTransform: "uppercase" }}
                    >
                      {item.sectionTitle}
                    </p>
                  );
                }

                return (
                  <Navigator
                    key={`nav-${idx}`}
                    name={item.name}
                    path={item.path}
                    path2={item.path2}
                    subPath3={item.path3}
                    iconName={item.iconName}
                    onClick={item.onClick}
                  >
                    {item.subMenu &&
                      item.subMenu.map((sub, subIdx) => (
                        <Navigator
                          key={`sub-${idx}-${subIdx}`}
                          subName={sub.subName}
                          subPath={sub.subPath}
                          subPath2={sub.subPath2}
                          subPath3={sub.subPath3}
                          onClick2={sub.onClick2}
                        />
                      ))}
                  </Navigator>

                );
              })}
            </nav>


          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
